// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   CSS Variables - Design System
   ========================================================================== */

:root {
  /* ========================================
     Typography
     ======================================== */

  /* Font Families */
  --font-primary:
    "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  --font-mono:
    "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New",
    monospace;

  /* Font Sizes */
  --text-xs: 0.75rem; /* 12px */
  --text-sm: 0.875rem; /* 14px */
  --text-base: 1rem; /* 16px */
  --text-lg: 1.125rem; /* 18px */
  --text-xl: 1.25rem; /* 20px */
  --text-2xl: 1.5rem; /* 24px */
  --text-3xl: 1.875rem; /* 30px */
  --text-4xl: 2.25rem; /* 36px */
  --text-5xl: 3rem; /* 48px */

  /* Font Weights */
  --font-light: 300;
  --font-normal: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;
  --font-extrabold: 800;

  /* Line Heights */
  --leading-none: 1;
  --leading-tight: 1.25;
  --leading-snug: 1.375;
  --leading-normal: 1.5;
  --leading-relaxed: 1.625;
  --leading-loose: 2;

  /* ========================================
     Colors - Primary Brand
     ======================================== */

  --color-primary-50: #eff6ff;
  --color-primary-100: #dbeafe;
  --color-primary-200: #bfdbfe;
  --color-primary-300: #93c5fd;
  --color-primary-400: #60a5fa;
  --color-primary-500: #3b82f6;
  --color-primary-600: #2563eb;
  --color-primary-700: #1d4ed8;
  --color-primary-800: #1e40af;
  --color-primary-900: #1e3a8a;

  /* ========================================
     Colors - Gray Scale
     ======================================== */

  --color-gray-50: #f9fafb;
  --color-gray-100: #f3f4f6;
  --color-gray-200: #e5e7eb;
  --color-gray-300: #d1d5db;
  --color-gray-400: #9ca3af;
  --color-gray-500: #6b7280;
  --color-gray-600: #4b5563;
  --color-gray-700: #374151;
  --color-gray-800: #1f2937;
  --color-gray-900: #111827;

  /* ========================================
     Colors - Success
     ======================================== */

  --color-success-50: #f0fdf4;
  --color-success-100: #dcfce7;
  --color-success-200: #bbf7d0;
  --color-success-300: #86efac;
  --color-success-400: #4ade80;
  --color-success-500: #22c55e;
  --color-success-600: #16a34a;
  --color-success-700: #15803d;
  --color-success-800: #166534;
  --color-success-900: #14532d;

  /* ========================================
     Colors - Warning
     ======================================== */

  --color-warning-50: #fffbeb;
  --color-warning-100: #fef3c7;
  --color-warning-200: #fde68a;
  --color-warning-300: #fcd34d;
  --color-warning-400: #fbbf24;
  --color-warning-500: #f59e0b;
  --color-warning-600: #d97706;
  --color-warning-700: #b45309;
  --color-warning-800: #92400e;
  --color-warning-900: #78350f;

  /* ========================================
     Colors - Error/Danger
     ======================================== */

  --color-error-50: #fef2f2;
  --color-error-100: #fee2e2;
  --color-error-200: #fecaca;
  --color-error-300: #fca5a5;
  --color-error-400: #f87171;
  --color-error-500: #ef4444;
  --color-error-600: #dc2626;
  --color-error-700: #b91c1c;
  --color-error-800: #991b1b;
  --color-error-900: #7f1d1d;

  /* ========================================
     Colors - Info
     ======================================== */

  --color-info-50: #f0f9ff;
  --color-info-100: #e0f2fe;
  --color-info-200: #bae6fd;
  --color-info-300: #7dd3fc;
  --color-info-400: #38bdf8;
  --color-info-500: #0ea5e9;
  --color-info-600: #0284c7;
  --color-info-700: #0369a1;
  --color-info-800: #075985;
  --color-info-900: #0c4a6e;

  /* ========================================
     Spacing Scale
     ======================================== */

  --spacing-0: 0;
  --spacing-1: 0.25rem; /* 4px */
  --spacing-2: 0.5rem; /* 8px */
  --spacing-3: 0.75rem; /* 12px */
  --spacing-4: 1rem; /* 16px */
  --spacing-5: 1.25rem; /* 20px */
  --spacing-6: 1.5rem; /* 24px */
  --spacing-7: 1.75rem; /* 28px */
  --spacing-8: 2rem; /* 32px */
  --spacing-10: 2.5rem; /* 40px */
  --spacing-12: 3rem; /* 48px */
  --spacing-16: 4rem; /* 64px */
  --spacing-20: 5rem; /* 80px */
  --spacing-24: 6rem; /* 96px */
  --spacing-32: 8rem; /* 128px */

  /* ========================================
     Border Radius
     ======================================== */

  --radius-none: 0;
  --radius-sm: 0.125rem; /* 2px */
  --radius-base: 0.25rem; /* 4px */
  --radius-md: 0.375rem; /* 6px */
  --radius-lg: 0.5rem; /* 8px */
  --radius-xl: 0.75rem; /* 12px */
  --radius-2xl: 1rem; /* 16px */
  --radius-3xl: 1.5rem; /* 24px */
  --radius-full: 9999px;

  /* ========================================
     Shadows
     ======================================== */

  --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --shadow-base:
    0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-md:
    0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-lg:
    0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);

  /* ========================================
     Transitions
     ======================================== */

  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);

  /* ========================================
     Z-Index Scale
     ======================================== */

  --z-0: 0;
  --z-10: 10;
  --z-20: 20;
  --z-30: 30;
  --z-40: 40;
  --z-50: 50;
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;

  /* ========================================
     Layout
     ======================================== */

  --max-width-xs: 20rem; /* 320px */
  --max-width-sm: 24rem; /* 384px */
  --max-width-md: 28rem; /* 448px */
  --max-width-lg: 32rem; /* 512px */
  --max-width-xl: 36rem; /* 576px */
  --max-width-2xl: 42rem; /* 672px */
  --max-width-3xl: 48rem; /* 768px */
  --max-width-4xl: 56rem; /* 896px */
  --max-width-5xl: 64rem; /* 1024px */
  --max-width-6xl: 72rem; /* 1152px */
  --max-width-7xl: 80rem; /* 1280px */
  --max-width-full: 100%;

  /* ========================================
     Breakpoints (for reference in JS)
     ======================================== */

  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;
}

/* ==========================================================================
   Dark Mode Variables
   ========================================================================== */

.dark {
  --color-bg-primary: var(--color-gray-900);
  --color-bg-secondary: var(--color-gray-800);
  --color-text-primary: var(--color-gray-50);
  --color-text-secondary: var(--color-gray-300);
  --color-border: var(--color-gray-700);
}

/* Light Mode Variables */
.light {
  --color-bg-primary: #ffffff;
  --color-bg-secondary: var(--color-gray-50);
  --color-text-primary: var(--color-gray-900);
  --color-text-secondary: var(--color-gray-600);
  --color-border: var(--color-gray-200);
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE;;+CAE6C;;EAE7C,kBAAkB;EAClB;;;cAGY;EACZ;;aAEW;;EAEX,eAAe;EACf,kBAAkB,EAAE,SAAS;EAC7B,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB,EAAE,SAAS;EAC5B,mBAAmB,EAAE,SAAS;EAC9B,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB,EAAE,SAAS;EAC/B,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB,EAAE,SAAS;;EAE3B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;;EAErB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;;EAElB;;+CAE6C;;EAE7C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B;;+CAE6C;;EAE7C,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB;;+CAE6C;;EAE7C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B;;+CAE6C;;EAE7C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B;;+CAE6C;;EAE7C,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B;;+CAE6C;;EAE7C,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB;;+CAE6C;;EAE7C,cAAc;EACd,oBAAoB,EAAE,QAAQ;EAC9B,mBAAmB,EAAE,QAAQ;EAC7B,oBAAoB,EAAE,SAAS;EAC/B,iBAAiB,EAAE,SAAS;EAC5B,oBAAoB,EAAE,SAAS;EAC/B,mBAAmB,EAAE,SAAS;EAC9B,oBAAoB,EAAE,SAAS;EAC/B,iBAAiB,EAAE,SAAS;EAC5B,oBAAoB,EAAE,SAAS;EAC/B,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,UAAU;;EAE9B;;+CAE6C;;EAE7C,gBAAgB;EAChB,qBAAqB,EAAE,QAAQ;EAC/B,sBAAsB,EAAE,QAAQ;EAChC,qBAAqB,EAAE,QAAQ;EAC/B,mBAAmB,EAAE,QAAQ;EAC7B,oBAAoB,EAAE,SAAS;EAC/B,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB,EAAE,SAAS;EAC/B,qBAAqB;;EAErB;;+CAE6C;;EAE7C,0CAA0C;EAC1C,0EAA0E;EAC1E;oEACkE;EAClE;sEACoE;EACpE;uEACqE;EACrE,gDAAgD;EAChD,iDAAiD;EACjD,mDAAmD;;EAEnD;;+CAE6C;;EAE7C,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;EACrD,uDAAuD;;EAEvD;;+CAE6C;;EAE7C,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;EAEjB;;+CAE6C;;EAE7C,qBAAqB,EAAE,UAAU;EACjC,qBAAqB,EAAE,UAAU;EACjC,qBAAqB,EAAE,UAAU;EACjC,qBAAqB,EAAE,UAAU;EACjC,qBAAqB,EAAE,UAAU;EACjC,sBAAsB,EAAE,UAAU;EAClC,sBAAsB,EAAE,UAAU;EAClC,sBAAsB,EAAE,UAAU;EAClC,sBAAsB,EAAE,WAAW;EACnC,sBAAsB,EAAE,WAAW;EACnC,sBAAsB,EAAE,WAAW;EACnC,sBAAsB;;EAEtB;;+CAE6C;;EAE7C,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,2CAA2C;EAC3C,6CAA6C;EAC7C,qCAAqC;AACvC","sourcesContent":["/* ==========================================================================\n   CSS Variables - Design System\n   ========================================================================== */\n\n:root {\n  /* ========================================\n     Typography\n     ======================================== */\n\n  /* Font Families */\n  --font-primary:\n    \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  --font-mono:\n    \"SF Mono\", Monaco, \"Cascadia Code\", \"Roboto Mono\", Consolas, \"Courier New\",\n    monospace;\n\n  /* Font Sizes */\n  --text-xs: 0.75rem; /* 12px */\n  --text-sm: 0.875rem; /* 14px */\n  --text-base: 1rem; /* 16px */\n  --text-lg: 1.125rem; /* 18px */\n  --text-xl: 1.25rem; /* 20px */\n  --text-2xl: 1.5rem; /* 24px */\n  --text-3xl: 1.875rem; /* 30px */\n  --text-4xl: 2.25rem; /* 36px */\n  --text-5xl: 3rem; /* 48px */\n\n  /* Font Weights */\n  --font-light: 300;\n  --font-normal: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  --font-bold: 700;\n  --font-extrabold: 800;\n\n  /* Line Heights */\n  --leading-none: 1;\n  --leading-tight: 1.25;\n  --leading-snug: 1.375;\n  --leading-normal: 1.5;\n  --leading-relaxed: 1.625;\n  --leading-loose: 2;\n\n  /* ========================================\n     Colors - Primary Brand\n     ======================================== */\n\n  --color-primary-50: #eff6ff;\n  --color-primary-100: #dbeafe;\n  --color-primary-200: #bfdbfe;\n  --color-primary-300: #93c5fd;\n  --color-primary-400: #60a5fa;\n  --color-primary-500: #3b82f6;\n  --color-primary-600: #2563eb;\n  --color-primary-700: #1d4ed8;\n  --color-primary-800: #1e40af;\n  --color-primary-900: #1e3a8a;\n\n  /* ========================================\n     Colors - Gray Scale\n     ======================================== */\n\n  --color-gray-50: #f9fafb;\n  --color-gray-100: #f3f4f6;\n  --color-gray-200: #e5e7eb;\n  --color-gray-300: #d1d5db;\n  --color-gray-400: #9ca3af;\n  --color-gray-500: #6b7280;\n  --color-gray-600: #4b5563;\n  --color-gray-700: #374151;\n  --color-gray-800: #1f2937;\n  --color-gray-900: #111827;\n\n  /* ========================================\n     Colors - Success\n     ======================================== */\n\n  --color-success-50: #f0fdf4;\n  --color-success-100: #dcfce7;\n  --color-success-200: #bbf7d0;\n  --color-success-300: #86efac;\n  --color-success-400: #4ade80;\n  --color-success-500: #22c55e;\n  --color-success-600: #16a34a;\n  --color-success-700: #15803d;\n  --color-success-800: #166534;\n  --color-success-900: #14532d;\n\n  /* ========================================\n     Colors - Warning\n     ======================================== */\n\n  --color-warning-50: #fffbeb;\n  --color-warning-100: #fef3c7;\n  --color-warning-200: #fde68a;\n  --color-warning-300: #fcd34d;\n  --color-warning-400: #fbbf24;\n  --color-warning-500: #f59e0b;\n  --color-warning-600: #d97706;\n  --color-warning-700: #b45309;\n  --color-warning-800: #92400e;\n  --color-warning-900: #78350f;\n\n  /* ========================================\n     Colors - Error/Danger\n     ======================================== */\n\n  --color-error-50: #fef2f2;\n  --color-error-100: #fee2e2;\n  --color-error-200: #fecaca;\n  --color-error-300: #fca5a5;\n  --color-error-400: #f87171;\n  --color-error-500: #ef4444;\n  --color-error-600: #dc2626;\n  --color-error-700: #b91c1c;\n  --color-error-800: #991b1b;\n  --color-error-900: #7f1d1d;\n\n  /* ========================================\n     Colors - Info\n     ======================================== */\n\n  --color-info-50: #f0f9ff;\n  --color-info-100: #e0f2fe;\n  --color-info-200: #bae6fd;\n  --color-info-300: #7dd3fc;\n  --color-info-400: #38bdf8;\n  --color-info-500: #0ea5e9;\n  --color-info-600: #0284c7;\n  --color-info-700: #0369a1;\n  --color-info-800: #075985;\n  --color-info-900: #0c4a6e;\n\n  /* ========================================\n     Spacing Scale\n     ======================================== */\n\n  --spacing-0: 0;\n  --spacing-1: 0.25rem; /* 4px */\n  --spacing-2: 0.5rem; /* 8px */\n  --spacing-3: 0.75rem; /* 12px */\n  --spacing-4: 1rem; /* 16px */\n  --spacing-5: 1.25rem; /* 20px */\n  --spacing-6: 1.5rem; /* 24px */\n  --spacing-7: 1.75rem; /* 28px */\n  --spacing-8: 2rem; /* 32px */\n  --spacing-10: 2.5rem; /* 40px */\n  --spacing-12: 3rem; /* 48px */\n  --spacing-16: 4rem; /* 64px */\n  --spacing-20: 5rem; /* 80px */\n  --spacing-24: 6rem; /* 96px */\n  --spacing-32: 8rem; /* 128px */\n\n  /* ========================================\n     Border Radius\n     ======================================== */\n\n  --radius-none: 0;\n  --radius-sm: 0.125rem; /* 2px */\n  --radius-base: 0.25rem; /* 4px */\n  --radius-md: 0.375rem; /* 6px */\n  --radius-lg: 0.5rem; /* 8px */\n  --radius-xl: 0.75rem; /* 12px */\n  --radius-2xl: 1rem; /* 16px */\n  --radius-3xl: 1.5rem; /* 24px */\n  --radius-full: 9999px;\n\n  /* ========================================\n     Shadows\n     ======================================== */\n\n  --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --shadow-base:\n    0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-md:\n    0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-lg:\n    0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n  --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n  --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n\n  /* ========================================\n     Transitions\n     ======================================== */\n\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* ========================================\n     Z-Index Scale\n     ======================================== */\n\n  --z-0: 0;\n  --z-10: 10;\n  --z-20: 20;\n  --z-30: 30;\n  --z-40: 40;\n  --z-50: 50;\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n\n  /* ========================================\n     Layout\n     ======================================== */\n\n  --max-width-xs: 20rem; /* 320px */\n  --max-width-sm: 24rem; /* 384px */\n  --max-width-md: 28rem; /* 448px */\n  --max-width-lg: 32rem; /* 512px */\n  --max-width-xl: 36rem; /* 576px */\n  --max-width-2xl: 42rem; /* 672px */\n  --max-width-3xl: 48rem; /* 768px */\n  --max-width-4xl: 56rem; /* 896px */\n  --max-width-5xl: 64rem; /* 1024px */\n  --max-width-6xl: 72rem; /* 1152px */\n  --max-width-7xl: 80rem; /* 1280px */\n  --max-width-full: 100%;\n\n  /* ========================================\n     Breakpoints (for reference in JS)\n     ======================================== */\n\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n  --breakpoint-2xl: 1536px;\n}\n\n/* ==========================================================================\n   Dark Mode Variables\n   ========================================================================== */\n\n.dark {\n  --color-bg-primary: var(--color-gray-900);\n  --color-bg-secondary: var(--color-gray-800);\n  --color-text-primary: var(--color-gray-50);\n  --color-text-secondary: var(--color-gray-300);\n  --color-border: var(--color-gray-700);\n}\n\n/* Light Mode Variables */\n.light {\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: var(--color-gray-50);\n  --color-text-primary: var(--color-gray-900);\n  --color-text-secondary: var(--color-gray-600);\n  --color-border: var(--color-gray-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
